export default "__VITE_ASSET__Do8Lnwf7__"